// SPDX-FileCopyrightText: 2022 - 2023 Netherlands eScience Center
// SPDX-FileCopyrightText: 2022 Dusan Mijatovic (dv4all)
// SPDX-FileCopyrightText: 2022 Ewan Cahen (Netherlands eScience Center) <e.cahen@esciencecenter.nl>
// SPDX-FileCopyrightText: 2022 dv4all
// SPDX-FileCopyrightText: 2023 Dusan Mijatovic (Netherlands eScience Center)
//
// SPDX-License-Identifier: Apache-2.0

export function saveLocationCookie() {
  // console.log('saveLocationCookie...', location.pathname.toLowerCase())
  // only in browser mode
  if (typeof document == 'undefined') return
  if (typeof location == 'undefined') return
  // for specific routes
  switch (location.pathname.toLowerCase()) {
    // ignore these paths
    case '/auth':
    case '/login':
    case '/logout':
    case '/login/local':
    case '/login/failed':
      break
    case '/':
      // root is send to /projects
      document.cookie = `rsd_pathname=${location.href}projects?order=impact_cnt;path=/auth;SameSite=None;Secure`
      break
    default:
      // write simple browser cookie
      // auth module use this cookie to redirect
      // after successful authentications
      document.cookie = `rsd_pathname=${location.href};path=/auth;SameSite=None;Secure`
  }
}
